//nodemodule imports
import React from "react";
import styled from "styled-components"
import { Link } from "react-router-dom";
import { scroller } from "react-scroll"

//project imports
import { TextP1, Title } from "./reusable/styles";

export default () => {

  const scroll = () => {
    scroller.scrollTo("contact", {
      duration: 1000,
      smooth: true,
      delay: 0,
      offset: 0,
    })
  }

  return(
    <Wrapper>
      <TopBar>
        <Link to={"/"} onClick={()=>window.scrollTo(0,0)}>
          <Logo src={'assets/images/headerImages/logo.svg'} alt={'assets/images/headerImages/logo.svg'}/>
        </Link>
        <Contact onClick={scroll}>Contact us</Contact>
      </TopBar>
      <InnerWrapper>
        <TitleWrapper>
          <Title theme={TitleTheme}>Disrupting traditional industries</Title>
        </TitleWrapper>
        <DescriptionWrapper>
          <TextP1 theme={TextP1Theme}>We provide an agile, sustainable and smart end-to-end experience</TextP1>
        </DescriptionWrapper>
        <BackgroundImage src={"assets/camacgroup/img1.png"}/>
      </InnerWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 100%;
  background: #D8D9DA;
  position: relative;
  margin: 0 auto;
  height: 85vh;
  //max-height: 1000px;
  min-height: 400px;
  @media (max-width: 900px) {
    max-height: 624px;
  }  
`

const BackgroundImage = styled.img`
  position: absolute;
  z-index: 1;
  width: 100%;
  bottom: 50px;
  @media (max-width: 740px) {
    object-fit: cover;
    width: 800px;
    left: -50px;
  }
`

const InnerWrapper = styled.div`
  max-width: 3000px;
  width: 100%;
  height: calc(100% - 100px);
  position: relative;
  display: flex;
  flex-direction:column;
  align-items: center;
  justify-content:center;
  background-repeat: no-repeat;
  background-size: 90%;
  background-position: 50% 80%;
  @media (max-width: 650px) {
    justify-content: flex-start;
    margin: 40px 0 0 0;
  }
`

const Contact = styled.a`
  cursor: pointer;
  user-select: none;
  font-family: GTAlpinaTrial;
  width: 160px;
  height: 48px;
  font-size: 24px;
  line-height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  letter-spacing: -0.1px;
  border: 1px solid #000000;
`

const TitleWrapper = styled.div`
  max-width: 761px;
  width: calc(100% - 40px);
  z-index: 2;
`

const DescriptionWrapper = styled.div`
  max-width: 528px;
  width: calc(100% - 40px);
  margin: 26px 0 100px 0;
  z-index: 2;

`

const TopBar = styled.div`
  width: calc(100% - 80px);
  margin: 0 auto;
  min-height: 100px;
  display: flex;
  align-items:center;
  justify-content: space-between;
  @media (max-width: 600px) {
    width: calc(100% - 40px);
  };
`
const Logo = styled.img`
  height: 22px;
  @media (max-width: 500px) {
    height: 17px;
  };
`

// const ButtonTheme = {
//   width: '128px',
//   height: '48px',
// }

const TitleTheme = {
  textAlign: 'center'
}

const TextP1Theme = {
  textAlign: 'center',
}
